<div class="created-text">
  <span class="created-text">
    Consent for application sucessfull. Please close this tab and continue the Onboarding Process.
  </span>
</div>
